const styles = {
  width: 30,
  height: 30,
  position: "absolute",
  top: "50%",
  transform: "translate(0, -50%)",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  background: "white"
};
const prevArrowStyles = { ...styles, left: "-70px", marginRight: "2px" };
const nextArrowStyles = { ...styles, right: "-70px", marginLeft: "1px" };
export {
  nextArrowStyles,
  prevArrowStyles
};
